import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSublimetextComponent } from './simple-icons-sublimetext.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSublimetextComponent ],
    exports:      [ SimpleIconsSublimetextComponent ],
    bootstrap:    []
})
export class SimpleIconsSublimetextModule {}
